export function scrollAnimate() {
    const _window = this._window;
    const _document = this._document;
    const isDesktop = !this.isTouch;
    const elements = _document.querySelectorAll(".scrolled");
    const addHeight = _window.innerHeight * 0.7; // optional
    let animateCoords = [];
    let scrolled = _window.scrollY || _window.pageYOffset;

    function detectElements() {
        animateCoords = [];
        [...elements].forEach((item) => {
            let elemProps = item.getBoundingClientRect();
            animateCoords.push({
                top: elemProps.top + scrolled
            });
        });
    }

    function animate() {
        if (isDesktop) {
            scrolled = _window.scrollY || _window.pageYOffset;
            [...animateCoords].forEach((item, index) => {
                if (item.top < (scrolled + addHeight)) {
                    if (!elements[index].classList.contains("animation")) {
                        elements[index].classList.add("animation");
                    }
                }
            });
        }
    }

    _window.addEventListener("load", () => {
        if (isDesktop) {
            detectElements();
            animate();
        }
    });

    _window.addEventListener("scroll", () => {
        if (isDesktop) {
            animate();
        }
    });

    _window.addEventListener("resize", () => {
        if (isDesktop) {
            detectElements();
            animate();
        }
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/scroll-animate.js